import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle } from "react-icons/fa";
import { IoCalendarOutline, IoSearch } from "react-icons/io5";
import { TopBar } from "../components/topbar";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { MenuContext } from "../context/MenuContext";
import { useNavigate } from "react-router-dom";
import { UpdateMembership } from "../components/updateMembershipRenewal";
import { TbCancel } from "react-icons/tb";

export default function Members() {
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [cookies] = useCookies();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [viewingItem, setViewingItem] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [offset])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        // Object.entries(formFields).forEach(([key, value]) => {
        //   formData.append(key, value);
        // });
        formData.append('offset', offset);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_members.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function searchData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_members.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col">
        <TopBar title={`Welcome, ${userProfile?.name}`} />
        {showModal && 
        <UpdateMembership
            setShowModal={setShowModal}
            getData={getData}
            item={viewingItem}
        />
        }
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="flex gap-y-2 md:gap-y-0 mt-3 md:mt-0 flex-col md:flex-row items-start md:items-center justify-end">
                <div className="flex items-center gap-x-2 self-end">
                    <div className="min-w-[30%] flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                        <div className="w-full flex items-center justify-between border rounded-xl p-1">
                            <input
                                type="text"
                                placeholder="Search name or email"
                                className="w-full bg-transparent focus:outline-none text-gray-700 px-2"
                                value={formFields?.search}
                                onChange={(e) => {setFormFields({...formFields, search: e.target.value}); }}
                            />
                            <button onClick={() => formFields?.search?.length > 0 ? searchData() : getData() } className="hover:opacity-[0.8] bg-[#000080] text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-3 rounded-xl shadow-md shrink-0 text-sm md:text-md">
                                <span className="text-white font-cormorant-bold text-sm md:text-md update-price"><IoSearch /></span>
                            </button>
                        </div>
                    </div>
                    <div className="text-center space-y-3">
                        <button onClick={() => navigate('create')} className="bg-[#000080] text-[#fff] rounded-[5px] py-2 px-4">Create New Member</button>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Name
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Member No.</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Email</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Phone</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Status</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Next Renewal
                            </div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600"></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.name}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.member_no}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.email}
                                </td>
                                <td className="px-2 py-2">
                                    {row.phone_number}
                                </td>
                                <td className="px-2 py-2">
                                    <div
                                    className={`inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm font-medium ${row.renewal_status ? 'text-[#00b47a] bg-[#bcffeaff]' : 'text-[#ff0000] bg-[#ffe2e0]'}`}
                                    >
                                    {row.renewal_status ? <FaRegCheckCircle className="w-4 h-4" /> : <TbCancel className="w-4 h-4" />}
                                    {row.renewal_status ? 'Active' : 'Expired'}
                                    </div>
                                </td>
                                <td className={`${row.renewal_status ? 'text-[#00b47a]' : 'text-[#ff0000]'} font-medium hidden md:table-cell px-2 py-2`}>
                                    {row.next_renewal}
                                </td>
                                <td className="px-2 py-2 gap-1">
                                    <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <button onClick={() => navigate(`/dashboard/members/edit-profile`, {state: {row}})} className="bg-[#000080] text-[#fff] rounded-[5px] py-2 px-4">Profile</button>
                                        {!row.renewal_status ? 
                                        <button onClick={() => {setShowModal(true);setViewingItem({...viewingItem, ...row})}} className="bg-[#000080] text-[#fff] rounded-[5px] py-2 px-4">Renew</button>
                                        :
                                        <button onClick={() => null} className="bg-[#000080]/50 text-[#fff] rounded-[5px] py-2 px-4">Renew</button>
                                        }
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
